import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Congratulation from "../page/Rank/components/popup/Congratulation";
import imgCongratulationRank from "../assets/web-v3-images/congratulation-rank.png";

// Popup chúc mừng thăng hạng Shwe Master — entry pu10 của popup manager (trước
// đây tự bật ở Home/index.jsx). onShown chạy ngay khi popup hiện để đánh dấu đã
// xem lần thăng hạng này, kể cả khi user reload thay vì bấm đóng.
export default function PopupRankMaster({ onShown, onClose }) {
  const { t } = useTranslation();

  useEffect(() => {
    onShown?.();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Congratulation
      open
      onOpenChange={(open) => !open && onClose()}
      title={t("rank.congratulation")}
      textDescribe={t("rank.you_now_a_Shwe_Master")}
      imgs={imgCongratulationRank}
      handleClick={onClose}
    />
  );
}
